import React from "react";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import { FormattedMoney } from "components/common/FormattedComponents";
import { formatMoney } from "../employee/shop/EnrollmentDataUtil";
import { injectIntl } from "react-intl";

const StandardMoney = ({ value, currency, intl, isUnlimited = false, postfix = false }) => {
  if (!currency || currency === "Flex Points") {
    if (isUnlimited) {
      return intl.formatMessage(messages.unlimitedDescription);
    } else {
      return formatMoney(value);
    }
  }
  return <FormattedMoney value={value} currency={currency} postfix={postfix} />;
};

StandardMoney.propTypes = {
  intl: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  isUnlimited: PropTypes.bool,
  postfix: PropTypes.bool,
};
export default injectIntl(StandardMoney);



// WEBPACK FOOTER //
// ./components/common/StandardMoney.jsx